import { component } from 'picoapp'
import $ from '../lib/quantdom'
import { get } from '../lib/ajax'

export default component((node) => {
  $(node).on('click', (e) => {
    e.preventDefault()
    const modal = $('#product-modal')
    const url = new URL(window.location)
    const targetCard = e.target.closest('a')
    const productUrl = targetCard.getAttribute('href')
    url.searchParams.set('view', 'modal-detail')

    get(productUrl + url.search)
      .then((res) => {
        replaceHTML(productUrl, res)
        modal.attr('open', true)
        $('body').attr('style', 'overflow:hidden')
        attachModalEvents()
      })
      .catch((err) => {
        console.log('Could not get product', err)
      })
  })

  function replaceHTML(productUrl, res) {
    const parser = new DOMParser()
    const doc = parser.parseFromString(res, 'text/html')
    const el = doc.querySelector('#js-modal-content')
    const html = el.innerHTML

    $('#product-modal').html(html)

    if (window?.productScroll && window?.productScroll?.active) {
      window.productScroll.stop()
    }
  }

  function attachModalEvents() {
    const closeButton = $('#product-modal [data-close-modal]')
    closeButton.on('click', (e) => {
      e.preventDefault()
      closeModal()
    })

    $('#product-modal').on('click', (e) => {
      e.preventDefault()
      const isOutside = !e.target.closest('#js-modal-content-inner')
      if (isOutside) {
        closeModal()
      }
    })

    $(document).on('keydown', (e) => {
      if (e.key === 'Escape') {
        const isOpen = $productModal.getAttribute('open') === 'true'
        if (isOpen) {
          closeModal()
        }
      }
    })
  }

  function closeModal() {
    $('#product-modal').attr('open', false)
    $('body').attr('style', 'overflow:unset')
  }
})
